module.exports = __webpack_public_path__ + "img/huitong.f8dda72f.png";